import { render, staticRenderFns } from "./chat-sidebar.vue?vue&type=template&id=62eb26f4&scoped=true&"
import script from "./chat-sidebar.vue?vue&type=script&lang=js&"
export * from "./chat-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./chat-sidebar.vue?vue&type=style&index=0&id=62eb26f4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62eb26f4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VProgressLinear})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62eb26f4')) {
      api.createRecord('62eb26f4', component.options)
    } else {
      api.reload('62eb26f4', component.options)
    }
    module.hot.accept("./chat-sidebar.vue?vue&type=template&id=62eb26f4&scoped=true&", function () {
      api.rerender('62eb26f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/chat-sidebar/chat-sidebar.vue"
export default component.exports